import { TenantEntity } from '../TenantEntity'
import { getPushConfig } from '@/api/sysManage/baseConfig/pushConfig'

export class SopPushConfig extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get officeId() {
    return this._data.officeId
  }
  set officeId(officeId) {
    this._data.officeId = officeId || 0
  }
  get ifAuto() {
    return this._data.ifAuto
  }
  set ifAuto(ifAuto) {
    this._data.ifAuto = ifAuto || false
  }
  get ifApplied() {
    return this._data.ifApplied
  }
  set ifApplied(ifApplied) {
    this._data.ifApplied = ifApplied || false
  }
  get ifEmail() {
    return this._data.ifEmail
  }
  set ifEmail(ifEmail) {
    this._data.ifEmail = ifEmail || false
  }
  get ifNote() {
    return this._data.ifNote
  }
  set ifNote(ifNote) {
    this._data.ifNote = ifNote || false
  }
  get ifSop() {
    return this._data.ifSop
  }
  set ifSop(ifSop) {
    this._data.ifSop = ifSop || false
  }
  get noteChinese() {
    return this._data.noteChinese
  }
  set noteChinese(noteChinese) {
    this._data.noteChinese = noteChinese
  }
  get noteEnglish() {
    return this._data.noteEnglish
  }
  set noteEnglish(noteEnglish) {
    this._data.noteEnglish = noteEnglish
  }
  static async findByOfficeId(officeId) {
    return await getPushConfig(officeId).then(res => res.data)
  }
}
